import { Link } from 'react-router-dom';
import { cn } from '../lib/cn.js';
import { teinte } from '../lib/teinte.js';
import type { Project } from '../api/projects.js';

/**
 * En-tête d'un groupe de tâches d'un même projet, dans Today et Board.
 *
 * C'est aussi le seul chemin vers `/p/:id` depuis les vues tâches : la liste de projets
 * a quitté la sidebar (ADR 0007) et l'affordance est le titre qu'on regardait déjà,
 * plutôt qu'un bandeau de chips qui aurait redit les mêmes pastilles quelques pixels
 * plus haut.
 */
export function ProjectHeading({
  project,
  count,
  as = 'h2',
  className,
}: {
  project: Project;
  count: number;
  as?: 'h2' | 'h3';
  className?: string | undefined;
}): React.ReactElement {
  const Tag = as;
  return (
    <Tag className={cn('mention', className)}>
      <Link
        to={`/p/${project.projectId}`}
        className="flex items-center gap-2 min-w-0 no-underline text-inherit hover:text-fg transition-colors"
      >
        <span className="point" style={teinte(project.color)} />
        <span className="truncate">{project.name}</span>
        <span className="shrink-0">&middot; {count}</span>
      </Link>
    </Tag>
  );
}
